import React from "react";

import { Background, LoadingDepiction, Section } from "@swa-ui/core";
import i18n from "@swa-ui/locale";

import styles from "./LoadingShimmer.module.scss";

const BACKGROUND_CLASSES = {
  placements: styles.placementsBackground,
};

const PLACEMENTS_TEMPLATE = [
  {
    className: styles.placementsButton,
    color: "var(--loading-shimmer-button)",
    height: "medium",
  },
];

const TOP_LEFT_TEMPLATE = [
  {
    bottomMargin: "large",
    color: "var(--loading-shimmer)",
    height: "xsmall",
  },
  {
    bottomMargin: "medium",
    color: "var(--loading-shimmer)",
    height: "small",
    style: { width: "90%" },
  },
  {
    bottomMargin: "xlarge",
    color: "var(--loading-shimmer)",
    height: "xsmall",
    style: { marginBottom: "1rem" },
  },
  {
    bottomMargin: "small",
    color: "var(--loading-shimmer)",
    height: "xsmall",
    topMargin: "xlarge",
  },
  {
    color: "var(--loading-shimmer)",
    height: "xsmall",
    style: { width: "90%" },
  },
];

const TOP_RIGHT_TEMPLATE = [
  {
    bottomMargin: "large",
    className: styles.rightElement,
    color: "var(--loading-shimmer-button)",
    height: "large",
  },
  {
    bottomMargin: "xsmall",
    className: styles.rightElement,
    color: "var(--loading-shimmer)",
    height: "xsmall",
  },
];

export const LoadingShimmer = () => {
  const getBackgroundProps = (type) => ({
    className: BACKGROUND_CLASSES[type],
    color: "var(--loading-shimmer)",
    shape: "rectangle",
  });

  const renderSection = (className, children) => (
    <Section className={className} grid={true}>
      {children}
    </Section>
  );

  const renderPlacementsSectionShimmer = () =>
    renderSection(
      styles.placementsLayout,
      <>
        {Array.from({ length: 3 }, (_, index) => (
          <div key={`placementShimmer_${index}`} className={styles.placementsContainer}>
            <Background {...getBackgroundProps("placements")}>
              <LoadingDepiction template={PLACEMENTS_TEMPLATE} />
            </Background>
          </div>
        ))}
      </>
    );

  const renderTopSectionShimmer = () =>
    renderSection(
      styles.topSectionLayout,
      <>
        <div className={styles.topLeftContainer}>
          <LoadingDepiction template={TOP_LEFT_TEMPLATE} />
        </div>
        <div className={styles.topRightContainer}>
          <LoadingDepiction template={TOP_RIGHT_TEMPLATE} />
        </div>
      </>
    );

  return (
    <div aria-label={i18n("LoadingShimmer__ARIA_LABEL_LOADING")} role="status">
      {renderTopSectionShimmer()}
      {renderPlacementsSectionShimmer()}
    </div>
  );
};
